import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import {
  SmsSubscriptionCredits,
  SmsCreditsUpdatePayload,
} from '../models/SmsSubscriptionCredits';

@Injectable()
export class SmsCreditSubscriptionService {
  private readonly apiUrl = `${this.apiBaseUrl}accounts`;

  constructor(
    @Inject('apiBaseUrl') private readonly apiBaseUrl: string,
    private readonly http: HttpClient,
  ) {}

  public getSmsSubscriptionCredits(
    accountId: string,
  ): Observable<SmsSubscriptionCredits> {
    return this.http.get<SmsSubscriptionCredits>(
      `${this.apiUrl}/${accountId}/sms-subscriptions`,
    ) as Observable<SmsSubscriptionCredits>;
  }

  public removeUpcomingSubscription(accountId: string, id: number) {
    return this.http.delete(
      `${this.apiUrl}/${accountId}/sms-subscriptions/packages/${id}`,
    );
  }

  public removeUpcomingTopUp(accountId: string, id: number) {
    return this.http.delete(
      `${this.apiUrl}/${accountId}/sms-subscriptions/top-ups/${id}`,
    );
  }

  public updateRenewalDate(
    accountId: string,
    payload: SmsCreditsUpdatePayload,
  ) {
    return this.http.post(
      `${this.apiUrl}/${accountId}/sms-subscriptions/renewal-date`,
      payload,
    );
  }

  public resetCredits(accountId: string) {
    return this.http.patch(
      `${this.apiUrl}/${accountId}/sms-subscriptions/unblock`,
      null,
    );
  }

  public updateSmsSubscriptionPackage(
    accountId: string,
    payload: SmsCreditsUpdatePayload,
  ) {
    return this.http.post(
      `${this.apiUrl}/${accountId}/sms-subscriptions/packages`,
      payload,
    );
  }

  public updateSmsSubscriptionTopUp(
    accountId: string,
    payload: SmsCreditsUpdatePayload,
  ) {
    return this.http.post(
      `${this.apiUrl}/${accountId}/sms-subscriptions/top-ups`,
      payload,
    );
  }
}
